import axios from "axios"
import * as types from "../mutation-types"
import api from "../../api/api"

export const state = {
    pagination: {
        from: 0,
        to: 0,
        totalPage: 0,
        path: "",
        currentPage: 1,
        totalRecord: 0,
        perPage: 10
    },
    shortLeaveRequests: [],
    shortLeaveRequestsExport: [],
    assignableEmployees: []
}

// getters
export const getters = {
    shortLeaveRequests: state => state.shortLeaveRequests,
    pagination: state => state.pagination,
    shortLeaveRequestsExport: state => state.shortLeaveRequestsExport,
    assignableEmployees: state => state.assignableEmployees
}

// mutations
export const mutations = {
    [types.SHORT_LEAVE_REQUEST.FETCH_SHORT_LEAVE_REQUEST](
        state,
        responseData
    ) {
        state.shortLeaveRequests = responseData.data
        state.pagination.from = responseData.pagination.from
        state.pagination.to = responseData.pagination.to
        state.pagination.totalPage = responseData.pagination.last_page
        state.pagination.path = responseData.pagination.path || ""
        state.pagination.currentPage = responseData.pagination.current_page
        state.pagination.totalRecord = responseData.pagination.total
        state.pagination.perPage = responseData.pagination.per_page
    },

    [types.SHORT_LEAVE_REQUEST.SET_PAGINATION](state, pagination) {
        state.pagination = { ...state.pagination, ...pagination }
    },

    [types.SHORT_LEAVE_REQUEST.FETCH_SHORT_LEAVE_REQUEST_EXPORT](state, data) {
        state.shortLeaveRequestsExport = data
    },

    [types.SHORT_LEAVE_REQUEST.SET_ASSIGNABLE_EMPLOYEES](state, employees) {
        state.assignableEmployees = employees
    }
}

// actions
export const actions = {
    async listShortLeaveRequests({ commit }, payload) {
        const response = await axios.get(api.LIST_SHORT_LEAVE_REQUEST, {
            params: {
                per_page: payload.per_page || 10,
                current_page: payload.current_page || 1,
                staff_id: payload.staff_id,
                staff_name: payload.staff_name,
                start_date: payload.start_date,
                end_date: payload.end_date,
                department_name: payload.department_name,
                leave_type: payload.leave_type,
                name_assign: payload.name_assign,
                start_time: payload.start_time,
                end_time: payload.end_time,
                sort_column: payload.sort_column,
                sort_by: payload.sort_by
            }
        })
        if (response.status === 'success') {
            commit(
                types.SHORT_LEAVE_REQUEST.FETCH_SHORT_LEAVE_REQUEST,
                response
            )
        }
    },

    async listShortLeaveRequestsAssign({ commit }, payload) {
        const response = await axios.get(api.LIST_SHORT_LEAVE_REQUEST_ASSIGN, {
            params: {
                per_page: payload.per_page || 10,
                current_page: payload.current_page || 1,
                staff_id: payload.staff_id,
                staff_name: payload.staff_name,
                start_date: payload.start_date,
                end_date: payload.end_date,
                department_name: payload.department_name,
                leave_type: payload.leave_type,
                name_assign: payload.name_assign,
                start_time: payload.start_time,
                end_time: payload.end_time,
                sort_column: payload.sort_column,
                sort_by: payload.sort_by
            }
        })
        if (response.status === 'success') {
            commit(
                types.SHORT_LEAVE_REQUEST.FETCH_SHORT_LEAVE_REQUEST,
                response
            )
        }
    },

    async listShortLeaveRequestsExport({ commit }, payload) {
        const response = await axios.get(api.LIST_SHORT_LEAVE_REQUEST_EXPORT, {
            params: {
                staff_id: payload.staff_id,
                staff_name: payload.staff_name,
                start_date: payload.start_date,
                end_date: payload.end_date,
                department_name: payload.department_name,
                leave_type: payload.leave_type,
                name_assign: payload.name_assign,
                start_time: payload.start_time,
                end_time: payload.end_time,
                sort_column: payload.sort_column,
                sort_by: payload.sort_by
            }
        })
        if (response.status === 'success') {
            commit(
                types.SHORT_LEAVE_REQUEST.FETCH_SHORT_LEAVE_REQUEST_EXPORT,
                response.data
            )
        }
    },

    async loadAssignableEmployees({ commit }) {
        try {
            const response = await axios.get('/api/get-request-assignable-positions')
            if (response.status === 200) {
                commit(types.SHORT_LEAVE_REQUEST.SET_ASSIGNABLE_EMPLOYEES, response.data.assign_to)
            }
        } catch (error) {
            console.error('Error loading assignable employees:', error)
            commit(types.SHORT_LEAVE_REQUEST.SET_ASSIGNABLE_EMPLOYEES, [])
        }
    }
}